module.exports = __webpack_public_path__ + "static/media/bets.c130b8ec.pdf";